export const TRAJ_STATION_TYPES = [
  'AZIMUTH_ON_PLANE',
  'BUILDRATE_TO_DELTA_MD',
  'BUILDRATE_TO_INCL',
  'BUILDRATE_TO_MD',
  'BUILDRATE_AND_TURNRATE_TO_AZI',
  'BUILDRATE_AND_TURNRATE_TO_DELTA_MD',
  'BUILDRATE_AND_TURNRATE_TO_INCL',
  'BUILDRATE_AND_TURNRATE_TO_INCL_AND_AZI',
  'BUILDRATE_AND_TURNRATE_TO_MD',
  'BUILDRATE_AND_TURNRATE_TO_TVD',
  'BUILDRATE_TVD',
  'CASING_MD',
  'CASING_TVD',
  'DLS',
  'DLS_TO_AZI_AND_MD',
  'DLS_TO_AZI_TVD',
  'DLS_TO_INCL',
  'DLS_TO_INCL_AND_AZI',
  'DLS_TO_INCL_AND_MD',
  'DLS_TO_INCL_AND_TVD',
  'DLS_TO_NS',
  'DLS_AND_TOOLFACE_TO_AZI',
  'DLS_AND_TOOLFACE_TO_DELTA_MD',
  'DLS_AND_TOOLFACE_TO_INCL',
  'DLS_AND_TOOLFACE_TO_INCL_AZI',
  'DLS_AND_TOOLFACE_TO_MD',
  'DLS_AND_TOOLFACE_TO_TVD',
  'EXTRAPOLATED',
  'FORMATION_MD',
  'FORMATION_TVD',
  'HOLD_TO_DELTA_MD',
  'HOLD_TO_MD',
  'HOLD_TO_TVD',
  'INCL_AZI_AND_TVD',
  'INTERPOLATED',
  'MARKER_MD',
  'MARKER_TVD',
  'MD_AND_INCL',
  'MD_INCL_AND_AZI',
  'N_E_AND_TVD',
  'NS_EW_AND_TVD',
  'TARGET_CENTER',
  'TARGET_OFFSET',
  'TIE_IN_POINT',
  'TURNRATE_TO_AZI',
  'TURNRATE_TO_DELTA_MD',
  'TURNRATE_TO_MD',
  'TURNRATE_TO_TVD',
  'UNKNOWN',
] as const;

export type TTrajStationType = (typeof TRAJ_STATION_TYPES)[number];

export function getTrajStationTypeTKey(type: string): string {
  return `TrajStationType.${type}`;
}
